import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=50a05b90&scoped=true&"
import script from "./AlertBanner.vue?vue&type=script&lang=ts&"
export * from "./AlertBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=50a05b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a05b90",
  null
  
)

export default component.exports